var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-btn',{staticClass:"my-2",attrs:{"color":"primary","loading":_vm.loading,"small":"","icon":""},on:{"click":_vm.openFileDialog}},[_c('v-icon',[_vm._v("mdi-upload")])],1),_c('input',{ref:"fileInput",staticStyle:{"display":"none"},attrs:{"type":"file"},on:{"change":_vm.onFileChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }